(function(){
  var root = document.getElementById('se2root');
  if(!root) return;
  var IMG='https://cdn.shopify.com/s/files/1/2117/6253/files/';
  var PRODUCTS=[
    {id:'awesome',vid:'33091409150032',name:'Awesome Sauce',tag:'Most popular',desc:'Cinnamon apple pie',kcal:180,vegan:true,caf:0,price:4.20,img:IMG+'AwesomeSauce_238dd1e6-b62c-4f4d-825e-dc853d9c1ce4.jpg',url:'/products/awesome-sauce-vegan',img2:IMG+'Awesome_Sauce_-_1_Benefits.png?v=1784739554'},
    {id:'canaberry',vid:'32340176928848',name:'Canaberry',tag:'Everyday training',desc:'Strawberry smoothie',kcal:100,vegan:true,caf:0,price:4.20,img:IMG+'canaberry2_983ea323-5074-41cc-ab75-914f5158c331.jpg',url:'/products/canaberry',img2:IMG+'Canaberry_-_1_Benefits_a6012244-5bf5-46c1-92d0-569f2abeaa2b.png?v=1784742384'},
    {id:'longhaul',vid:'32340587315280',name:'Long Haul',tag:'Long efforts',desc:'Peanut butter & fruit',kcal:140,vegan:false,caf:0,price:4.20,img:IMG+'LongHaul_d67f058f-ab80-4bb7-9262-8754d06ffc31.jpg',url:'/products/long-haul-energy-gel',img2:IMG+'Long_Haul_-_1_Benefits.png?v=1784742544'},
    {id:'peach',vid:'41265438359632',name:'Peach Cobbler XL',tag:'Ultra distance',desc:'Peach cobbler · biggest fuel',kcal:210,vegan:false,caf:0,price:6.90,img:IMG+'peachcoutout1800.jpg',url:'/products/peach-cobbler-gel-210-kcal',img2:IMG+'Peach_Cobbler_Gel_XL_Benefits_Slide-selection.png?v=1784739614'},
    {id:'mango',vid:'32743825571920',name:'Mango Mint',tag:'Caffeine · 30 mg',desc:'Mango mint · a mid-race lift',kcal:120,vegan:true,caf:30,price:4.20,img:IMG+'HillAid.jpg',url:'/products/hill-aid-energy-gel-with-30-mg-caffein-100-kcal',caff:true,img2:IMG+'Mango_Mint_-_1_Benefits.png?v=1784742468'},
    {id:'speednut',vid:'32341509701712',name:'Speednut',tag:'Caffeine · 50 mg',desc:'Nuts & berries',kcal:250,vegan:true,caf:50,price:4.60,img:IMG+'Speednut_02135314-9db2-4c7e-b894-a4212364513d.jpg',url:'/products/speednut-caffeinated-energy-gel',caff:true,img2:IMG+'Speednut_-_1_Benefits.png?v=1784742600'}
  ];
  var SAMPLER_URL='/products/bestseller-sampler-5-qty-free-shipping';
  function byId(id){for(var i=0;i<PRODUCTS.length;i++){if(PRODUCTS[i].id===id)return PRODUCTS[i];}return null;}

  /* product grid */
  var pgrid=root.querySelector('#pgrid');
  if(pgrid){
    pgrid.innerHTML=PRODUCTS.map(function(p){return ''+
      '<div class="pcard">'+
        '<a class="pcard-media" href="'+p.url+'" aria-label="'+p.name+'">'+
          '<div class="pimg"><span class="ptag '+(p.caff?'caf':'')+'">'+p.tag+'</span>'+
            '<img src="'+p.img+'?width=500" alt="'+p.name+' energy gel" loading="lazy">'+
            '<div class="pswap-wrap"><img src="'+p.img2+'&width=600" alt="'+p.name+' benefits" loading="lazy"></div></div>'+
        '</a>'+
        '<div class="pbody"><a class="pcard-title" href="'+p.url+'"><h3>'+p.name+'</h3></a>'+
          '<div class="desc"><b>'+p.desc+'</b> · '+p.kcal+' kcal'+(p.vegan?' · vegan':'')+'</div>'+
          '<div class="pfoot"><span class="price">$'+p.price.toFixed(2)+'</span>'+
          '<button type="button" class="add" data-id="'+p.vid+'" data-name="'+p.name+'"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.5"/><circle cx="17" cy="20" r="1.5"/><path d="M2 3h3l2.2 11.4a1.5 1.5 0 0 0 1.5 1.2h7.7a1.5 1.5 0 0 0 1.5-1.2L21 7H6"/></svg>Add to cart</button></div>'+
        '</div>'+
      '</div>';}).join('');
  }

  /* gel finder */
  var answers={dist:null,goal:null};
  var steps=root.querySelectorAll('.step');
  var resultEl=root.querySelector('.result');
  var p1=root.querySelector('#p1'), p2=root.querySelector('#p2');
  function show(step){
    for(var i=0;i<steps.length;i++){steps[i].classList.toggle('active', steps[i].getAttribute('data-step')==step);}
    if(resultEl) resultEl.classList.toggle('active', step=='result');
    if(p2) p2.classList.toggle('on', step==2||step=='result');
  }
  var opts=root.querySelectorAll('.opt');
  for(var i=0;i<opts.length;i++){
    opts[i].addEventListener('click', function(){
      answers[this.getAttribute('data-q')]=this.getAttribute('data-val');
      if(this.getAttribute('data-q')=='dist'){show(2);}
      else{recommend();show('result');}
    });
  }
  var backBtn=root.querySelector('#backBtn'); if(backBtn) backBtn.addEventListener('click',function(){show(1);});
  var restartBtn=root.querySelector('#restartBtn'); if(restartBtn) restartBtn.addEventListener('click',function(){answers.dist=null;answers.goal=null;show(1);});

  function recommend(){
    var dist=answers.dist, goal=answers.goal, pick='canaberry';
    if(goal=='caffeine'){ pick=(dist=='long'||dist=='ultra')?'speednut':'mango'; }
    else if(goal=='flavor'){ pick='sampler'; }
    else if(goal=='calories'){ pick=(dist=='ultra')?'peach':(dist=='long'?'speednut':'awesome'); }
    else { pick={short:'canaberry',mid:'awesome',long:'longhaul',ultra:'peach'}[dist]||'awesome'; }

    var WHY={
      canaberry:'Light, 100-calorie real-food energy that goes down easy — perfect for shorter, steady efforts.',
      awesome:'Our most-loved gel: 180 balanced calories of cinnamon apple pie for those 1–3 hour days.',
      longhaul:'Peanut butter and fruit add natural fats, so the energy keeps coming deep into long efforts.',
      peach:'The XL — 210 calories of real fuel for ultra distances, so you carry fewer and manage less.',
      mango:'A 30 mg caffeine lift in a mint-mango gel that still sits easy when the pace bites.',
      speednut:'250 calories plus a 50 mg caffeine kick — big fuel for long, hard days.'
    };
    var tagEl=root.querySelector('#rTag'), nameEl=root.querySelector('#rName'), whyEl=root.querySelector('#rWhy'),
        imgEl=root.querySelector('#rImg'), priceEl=root.querySelector('#rPrice'), metaEl=root.querySelector('#rMeta'),
        addEl=root.querySelector('#rAdd');

    if(pick=='sampler'){
      tagEl.textContent='Best way to explore';
      nameEl.textContent='The Sampler Pack';
      whyEl.textContent='Since you’re here for the flavors, taste the whole range first — 5 gels, all rice, fruit and honey, no maltodextrin.';
      imgEl.src=byId('awesome').img+'?width=400';
      var heroPrice=root.querySelector('.hero-buy-price');
      priceEl.textContent=(heroPrice&&heroPrice.textContent.trim())||'$25.99';
      metaEl.innerHTML='<span><b>5</b> gels</span><span><b>Free</b> shipping</span><span><b>All</b> flavors</span>';
      addEl.setAttribute('href', SAMPLER_URL);
      return;
    }
    var p=byId(pick);
    tagEl.textContent=p.tag;
    nameEl.textContent=p.name;
    whyEl.textContent=WHY[pick];
    imgEl.src=p.img+'?width=400'; imgEl.alt=p.name;
    priceEl.textContent='$'+p.price.toFixed(2);
    metaEl.innerHTML='<span><b>'+p.kcal+'</b> kcal</span>'+
      (p.caf?'<span><b>'+p.caf+'mg</b> caffeine</span>':'')+
      (p.vegan?'<span><b>Vegan</b></span>':'')+'<span>'+p.desc+'</span>';
    addEl.setAttribute('href', p.url);
  }

  /* testimonial slider */
  var track=root.querySelector('#track');
  if(track){
    var slides=track.children.length, dotsWrap=root.querySelector('#dots'), idx=0, auto;
    for(var d=0; d<slides; d++){ (function(k){ var b=document.createElement('button'); b.className='dot'+(k===0?' on':''); b.addEventListener('click',function(){go(k);reset();}); dotsWrap.appendChild(b); })(d); }
    var dotEls=dotsWrap.children;
    function go(n){ idx=(n+slides)%slides; track.style.transform='translateX(-'+(idx*100)+'%)'; for(var k=0;k<dotEls.length;k++){dotEls[k].classList.toggle('on',k===idx);} }
    var nx=root.querySelector('#next'), pv=root.querySelector('#prev');
    if(nx) nx.addEventListener('click',function(){go(idx+1);reset();});
    if(pv) pv.addEventListener('click',function(){go(idx-1);reset();});
    function play(){ auto=setInterval(function(){go(idx+1);},5000); }
    function reset(){ clearInterval(auto); play(); }
    play();
  }

  /* FAQ accordion */
  var accs=root.querySelectorAll('#faq-list .acc');
  for(var a=0;a<accs.length;a++){
    (function(acc){
      var q=acc.querySelector('.acc-q'), ans=acc.querySelector('.acc-a');
      if(acc.classList.contains('open')) ans.style.maxHeight=ans.scrollHeight+'px';
      q.addEventListener('click', function(){
        var open=acc.classList.contains('open');
        for(var j=0;j<accs.length;j++){ accs[j].classList.remove('open'); accs[j].querySelector('.acc-a').style.maxHeight=0; }
        if(!open){ acc.classList.add('open'); ans.style.maxHeight=ans.scrollHeight+'px'; }
      });
    })(accs[a]);
  }

  /* reveal on scroll */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
    root.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
    var chart=root.querySelector('.chart-svg');
    if(chart){ var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){chart.classList.add('in');cio.unobserve(chart);}});},{threshold:.4}); cio.observe(chart); }
    var trust=root.querySelector('.trust'), bar=root.querySelector('#stickyBar');
    if(trust&&bar){ var sio=new IntersectionObserver(function(es){es.forEach(function(e){bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top<0);});},{threshold:0}); sio.observe(trust); }
  } else {
    root.querySelectorAll('.rv').forEach(function(el){el.classList.add('in');});
    var c2=root.querySelector('.chart-svg'); if(c2) c2.classList.add('in');
  }

  /* smooth scroll for in-page anchors */
  root.querySelectorAll('a[href^="#se2-"]').forEach(function(link){
    link.addEventListener('click', function(e){
      var t=document.getElementById(this.getAttribute('href').slice(1));
      if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'}); }
    });
  });
  /* add to cart */
  (function(){
    var toast=document.createElement('div');
    toast.className='toast';
    toast.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M20 6 9 17l-5-5"/></svg><span class="toast-txt">Added to cart</span><a href="/cart" class="toast-link">View cart</a>';
    root.appendChild(toast);
    var tt;
    function showToast(msg){ toast.querySelector('.toast-txt').textContent=msg; toast.classList.add('show'); clearTimeout(tt); tt=setTimeout(function(){toast.classList.remove('show');},3500); }
    function setCount(n){ document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, .cart-link__bubble, #cart-icon-bubble span').forEach(function(el){ try{ el.textContent=n; }catch(_){} }); }
    root.querySelectorAll('.add[data-id]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var id=btn.getAttribute('data-id');
        if(!id||btn.classList.contains('loading')||btn.classList.contains('added')) return;
        var orig=btn.innerHTML;
        btn.classList.add('loading');
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
          .then(function(r){ if(!r.ok) throw 0; return r.json(); })
          .then(function(){
            btn.classList.remove('loading'); btn.classList.add('added');
            btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"><path d="M20 6 9 17l-5-5"/></svg>Added';
            showToast((btn.getAttribute('data-name')||'Gel')+' added to cart');
            fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ setCount(c.item_count); try{document.dispatchEvent(new CustomEvent('cart:refresh',{detail:c}));}catch(_){}}).catch(function(){});
            setTimeout(function(){ btn.classList.remove('added'); btn.innerHTML=orig; },2200);
          })
          .catch(function(){ btn.classList.remove('loading'); btn.innerHTML=orig; showToast('Could not add — please try again'); });
      });
    });
  })();

  /* chart hover hotspots */
  (function(){
    var svg=root.querySelector('.chart-svg');
    if(!svg) return;
    var NS='http://www.w3.org/2000/svg';
    function mk(name,attrs){ var e=document.createElementNS(NS,name); for(var k in attrs){ e.setAttribute(k,attrs[k]); } return e; }
    function spot(cx,cy,label,ly,pw,fill){
      var g=mk('g',{'class':'hot'});
      g.appendChild(mk('line',{x1:cx,y1:cy,x2:cx,y2:(ly>cy?ly-13:ly+13),stroke:fill,'stroke-width':1.4,'stroke-dasharray':'2 3'}));
      g.appendChild(mk('circle',{cx:cx,cy:cy,r:6,fill:'none',stroke:fill,'stroke-width':2,'class':'pulse'}));
      g.appendChild(mk('circle',{cx:cx,cy:cy,r:5,fill:fill,stroke:'#fff','stroke-width':1.5}));
      g.appendChild(mk('rect',{x:cx-pw/2,y:ly-13,width:pw,height:24,rx:12,fill:fill}));
      var t=mk('text',{x:cx,y:ly+4.5,'text-anchor':'middle',fill:'#fff','font-size':13,'font-weight':700,'font-family':'Roboto,system-ui,sans-serif'});
      t.textContent=label; g.appendChild(t);
      svg.appendChild(g);
    }
    spot(190,74,'GI problems',46,98,'#c2604f');
    spot(445,266,'sugar crash',240,94,'#c2604f');
  })();

})();
